// CORES
import React, { Component } from 'react'

// COMPONENTS
import { 
	ModuleOne, 
	ModuleSix, 
	ModuleSeven, 
	ModuleFive } from '../../../components/Modules'

// STYLES
import classes from '../layout.css'

class OrthognathicSurgery extends Component {
	render() {
		const { addToForm, consentForm } = this.props
		return (
			<form id={consentForm.formId} className={classes.Container}>
				<h2>{consentForm.formName}</h2>

				<ModuleOne 
					addToForm={addToForm} 
					consentForm={consentForm}
				/>
				<p><strong>Please initial each paragraph after reading. If you have any questions, please ask your doctor BEFORE initialing.</strong></p>
				<p>Orthognathic surgery is being planned for you, and it is important that you understand the benefits and risks of such surgery. This is NOT minor surgery and you have the right to be fully informed about your condition and the recommended treatment plan. The disclosures in this consent are not meant to alarm you, but rather to provide information you need in order to give or withhold your consent to the planned surgery.</p>
				<ModuleSix 
					addToForm={addToForm}
					consentForm={consentForm}
				/>
				<ModuleSeven 
					addToForm={addToForm}
					consentForm={consentForm} 
				/>
				<h3>CONSENT</h3>
				By signing this consent form, I acknowledge that I have read it completely and understand the procedure to be performed, the risks, and the alternatives to surgery. I have had all my questions answered to my satisfaction. I was under no pressure to sign this form and have made a voluntary choice to proceed with surgery. I am fully aware that no guarantee or warranty can be made regarding the results of treatment. I certify that I speak, read and write English.
				<ModuleFive 
					addToForm={addToForm}
					consentForm={consentForm} 
				/>
			</form>
		)
	}
}

export default OrthognathicSurgery


// WEBPACK FOOTER //
// ./src/containers/FormLayout/Form/0.js